import getEnv from "@/config/env";
import { retrieveProdInformation } from "@/helpers/helper";
import { getDestinationInfoByExtension } from "@/helpers/Destination_Information";

let soft_phone_info = [
  // Software (ソフトフォン) Phones

  { phone: "COMPL_DL073", name: "植竹 えり子" },
  { phone: "COMPL_DL1000", name: "共用" },
  { phone: "COMPL_DL1009", name: "共用" },
  { phone: "COMPL_DL1010", name: "共用" },
  { phone: "COMPL_DL1013", name: "共用" },
  { phone: "COMPL_DL1022", name: "共用" },
  { phone: "COMPL_DL1031", name: "共用" },
  { phone: "COMPL_DL1036", name: "望月 樹" },
  { phone: "COMPL_DL1059", name: "共用" },
  { phone: "COMPL_DL1060", name: "共用" },
  { phone: "COMPL_DL11", name: "共用" },
  { phone: "COMPL_DL1171", name: "中山 多美子" },
  { phone: "COMPL_DL1265", name: "共用" },
  { phone: "COMPL_DL1285", name: "共用" },
  { phone: "COMPL_DL1286", name: "共用" },
  { phone: "COMPL_DL1295", name: "共用" },
  { phone: "COMPL_DL1296", name: "共用" },
  { phone: "COMPL_DL1297", name: "共用" },
  { phone: "COMPL_DL531", name: "共用" },
  { phone: "COMPL_DL638", name: "白戸 凌" },
  { phone: "COMPL_DL658", name: "共用" },
  { phone: "COMPL_DL664", name: "共用" },
  { phone: "COMPL_DL672", name: "共用" },
  { phone: "DL005", name: "岩永 勝彦" },
  { phone: "DL1007", name: "カスハラサービスサポートチーム" },
  { phone: "DL1095", name: "山﨑 彩" },
  { phone: "DL1269", name: "清水 布紗" },
  { phone: "EAP_DL067", name: "川田 瑠璃" },
  // { phone: "EAP_DL1002", name: "共用" },
  // { phone: "EAP_DL1016", name: "共用" },
  { phone: "EAP_DL1021", name: "佐々木 淳子" },
  { phone: "EAP_DL1028", name: "共用" },
  { phone: "EAP_DL1032", name: "コンプラの研修利用アカウント６" },
  { phone: "EAP_DL1033", name: "鈴木 里枝" },
  // { phone: "EAP_DL1042", name: "共用" },
  { phone: "EAP_DL1052", name: "共用" },
  { phone: "EAP_DL1125", name: "共用" },
  { phone: "EAP_DL1142", name: "共用" },
  { phone: "EAP_DL1179", name: "佐々木 淳子" },
  // { phone: "EAP_DL1268", name: "共用" },
  { phone: "EAP_DL1290", name: "共用" },
  { phone: "EAP_DL580", name: "共用" },
  { phone: "EAP_DL614", name: "共用" },
  // { phone: "EAP_DL615", name: "共用" },
  // { phone: "EAP_DL616", name: "共用" },
  { phone: "EAP_DL619", name: "共用" },
  { phone: "EAP_DL843", name: "共用" },
  { phone: "JOSYS_DL074", name: "小峰 千明" },
  { phone: "JOSYS_DL083", name: "稲垣 雄也" },
  { phone: "JOSYS_DL1003", name: "共用" },
  { phone: "JOSYS_DL1006", name: "磯部 花菜子" },
  { phone: "JOSYS_DL1097", name: "共用" },
  { phone: "JOSYS_DL1109", name: "冨吉 凪人" },
  { phone: "josys_DL1170", name: "白戸 凌" },
  { phone: "josys_DL1264", name: "佐藤 柚香" },
  { phone: "KENKO_DL047", name: "町田 敦子" },
  { phone: "KENKO_DL062", name: "小山 美樹" },
  { phone: "KENKO_DL078", name: "細田 幸子" },
  { phone: "KENKO_DL1001", name: "近藤 真理奈" },
  { phone: "KENKO_DL1023", name: "鈴木 圭子" },
  { phone: "KENKO_DL1046", name: "共用" },
  { phone: "KENKO_DL1047", name: "共用" },
  { phone: "KENKO_DL1048", name: "共用" },
  { phone: "KENKO_DL1050", name: "共用" },
  { phone: "KENKO_DL1053", name: "共用" },
  { phone: "KENKO_DL1090", name: "共用" },
  { phone: "KENKO_DL1093", name: "共用" },
  { phone: "KENKO_DL1101", name: "共用" },
  { phone: "KENKO_DL1102", name: "共用" },
  { phone: "KENKO_DL1120", name: "共用" },
  { phone: "KENKO_DL1130", name: "共用" },
  { phone: "KENKO_DL1175", name: "横山 あき子" },
  { phone: "KENKO_DL1183", name: "今井 桂" },
  { phone: "KENKO_DL1202", name: "共用" },
  { phone: "KENKO_DL1205", name: "共用" },
  { phone: "KENKO_DL1206", name: "共用" },
  { phone: "KENKO_DL1208", name: "共用" },
  { phone: "KENKO_DL1209", name: "共用" },
  { phone: "KENKO_DL1210", name: "共用" },
  { phone: "KENKO_DL1211", name: "共用" },
  { phone: "KENKO_DL1212", name: "佐藤 真奈美" },
  { phone: "KENKO_DL1213", name: "共用" },
  { phone: "KENKO_DL1214", name: "共用" },
  { phone: "KENKO_DL1215", name: "共用" },
  { phone: "KENKO_DL1216", name: "共用" },
  { phone: "KENKO_DL1217", name: "共用" },
  { phone: "KENKO_DL1218", name: "共用" },
  { phone: "KENKO_DL1219", name: "共用" },
  { phone: "KENKO_DL1220", name: "共用" },
  { phone: "KENKO_DL1221", name: "共用" },
  { phone: "KENKO_DL1223", name: "共用" },
  { phone: "KENKO_DL1225", name: "共用" },
  { phone: "KENKO_DL1226", name: "共用" },
  { phone: "KENKO_DL1227", name: "共用" },
  { phone: "KENKO_DL1228", name: "大野 愛" },
  { phone: "KENKO_DL1229", name: "共用" },
  { phone: "KENKO_DL1231", name: "共用" },
  { phone: "KENKO_DL1234", name: "共用" },
  { phone: "KENKO_DL1235", name: "藤澤 裕子" },
  { phone: "KENKO_DL1237", name: "共用" },
  { phone: "KENKO_DL1238", name: "共用" },
  { phone: "KENKO_DL1240", name: "上原 佳子" },
  { phone: "KENKO_DL1241", name: "共用" },
  { phone: "KENKO_DL1242", name: "共用" },
  { phone: "KENKO_DL1244", name: "共用" },
  { phone: "KENKO_DL1245", name: "共用" },
  { phone: "KENKO_DL1253", name: "共用" },
  { phone: "KENKO_DL1255", name: "山田 千裕" },
  { phone: "KENKO_DL1256", name: "木田 雅代" },
  { phone: "KENKO_DL1257", name: "木田 雅代" },
  { phone: "KENKO_DL1258", name: "西川 文恵" },
  { phone: "KENKO_DL1260", name: "共用" },
  { phone: "KENKO_DL1267", name: "勝井 由美" },
  { phone: "KENKO_DL1327", name: "冨田 大介" },
  { phone: "SOC_DL076", name: "松岡 千里" },
  { phone: "SOC_DL080", name: "松岡 千里" },
  { phone: "SOC_DL085", name: "大村 恒平" },
  { phone: "SOC_DL1062", name: "共用" },
  { phone: "SOC_DL1063", name: "共用" },
  { phone: "SOC_DL1065", name: "共用" },
  { phone: "SOC_DL1066", name: "共用" },
  { phone: "SOC_DL1067", name: "共用" },
  { phone: "SOC_DL1068", name: "共用" },
  { phone: "SOC_DL1069", name: "共用" },
  { phone: "SOC_DL1084", name: "共用" },
  { phone: "SOC_DL1086", name: "共用" },
  { phone: "SOC_DL1087", name: "共用" },
  { phone: "SOC_DL1091", name: "共用" },
  { phone: "SOC_DL1104", name: "共用" },
  { phone: "SOC_DL1106", name: "共用" },
  { phone: "SOC_DL1107", name: "安田 悦子" },
  { phone: "SOC_DL1111", name: "共用" },
  { phone: "SOC_DL1112", name: "共用" },
  { phone: "SOC_DL1113", name: "共用" },
  { phone: "SOC_DL1114", name: "共用" },
  { phone: "SOC_DL1115", name: "共用" },
  { phone: "SOC_DL1118", name: "共用" },
  { phone: "SOC_DL1127", name: "共用" },
  { phone: "SOC_DL1131", name: "共用" },
  { phone: "SOC_DL1133", name: "共用" },
  { phone: "SOC_DL1180", name: "小板橋 理惠" },
  { phone: "SOC_DL1181", name: "鈴木 浩之" },
  { phone: "SOC_DL1222", name: "共用" },
  { phone: "SOC_DL1302", name: "高野 翔英" },
  { phone: "SOC_DL1303", name: "川田 有香" },
  { phone: "SOC_DL1315", name: "河野 維義" },
  { phone: "SOC_DL1319", name: "滋野 めぐみ" },
  { phone: "SOC_DL1328", name: "青﨑 祐子" },
  { phone: "SOC_DL316", name: "共用" },
  { phone: "SOC_DL844", name: "共用" },
  { phone: "SOC_DL851", name: "桜井 憲児朗" },
  { phone: "SOC_DL853", name: "大西 住江" },
  { phone: "SOC_DL854", name: "共用" },
  { phone: "SOC_DL855", name: "工藤 智" },
  { phone: "SOC_DL856", name: "河野 智佳子" },
  { phone: "SOC_DL858", name: "宮坂 勇" },
  { phone: "SOC_DL859", name: "荒木 郷子" },
  { phone: "SOC_DL872", name: "鴨澤 真広" },
  { phone: "TAS_DL046", name: "服部 美智代" },
  { phone: "TAS_DL1005", name: "倉田 由起子" },
  { phone: "TAS_DL1008", name: "共用" },
  { phone: "TAS_DL1024", name: "田内 圭子" },
  { phone: "TAS_DL1025", name: "川島 早苗" },
  { phone: "TAS_DL1026", name: "長尾 美百合" },
  { phone: "TAS_DL1027", name: "池田 真実" },
  { phone: "TAS_DL1037", name: "共用" },
  { phone: "TAS_DL1054", name: "小野田 光一" },
  { phone: "TAS_DL1056", name: "松阪 祐美子" },
  { phone: "TAS_DL1160", name: "家久来 玲子" },
  { phone: "TAS_DL1169", name: "共用" },
  { phone: "TAS_DL1174", name: "共用" },
  { phone: "TAS_DL1182", name: "共用" },
  { phone: "TAS_DL1300", name: "共用" },
  { phone: "TAS_DL1301", name: "共用" },
  { phone: "TAS_DL1304", name: "中山 扶美" },
  { phone: "TAS_DL1305", name: "大泉 直子" },
  { phone: "TAS_DL1336", name: "内藤 徳子" },
  { phone: "TAS_DL1337", name: "太田 久美子" },
  { phone: "TAS_DL1289", name: "共用" },
  { phone: "TAS_DL562", name: "共用" },
  { phone: "TAS_DL576", name: "共用" },
  { phone: "TAS_DL577", name: "共用" },
  { phone: "TAS_DL655", name: "共用" },
  { phone: "TAS_DL837", name: "共用" },
  { phone: "TAS_DL839", name: "共用" },
  { phone: "TAS_DL841", name: "九里 智佳" },

  // Smart (スマホ) Phones

  { phone: "070-7799-0884", name: "山﨑 彩" },
  { phone: "080-6845-7999", name: "細谷 幸子" },
  { phone: "080-5982-9258", name: "松阪 祐美子" },
  { phone: "070-7799-0930", name: "清水 布紗" },
  { phone: "090-4455-1841", name: "細谷 幸子" },
  { phone: "090-8082-3957", name: "" },
  { phone: "070-7799-0912", name: "" },
  { phone: "070-7799-0896", name: "冨吉 凪人" },
  { phone: "080-9889-5522", name: "小峰 千明" },
  { phone: "070-7468-5365", name: "磯部 花菜子" },
  { phone: "070-7468-5364", name: "白戸 凌" },
  { phone: "070-7799-0919", name: "今井 晃穂" },
  { phone: "080-5973-7076", name: "細田 幸子" },
  { phone: "080-9367-3667", name: "但馬 裕子" },
  { phone: "070-7799-0902", name: "但馬 裕子" },
  { phone: "070-7790-3261", name: "勝井 由美" },
  { phone: "070-7799-0907", name: "NTT工事用" },
  { phone: "070-7790-3252", name: "近藤 真理奈" },
  { phone: "070-7799-0880", name: "日向 和江" },
  { phone: "070-7799-0956", name: "木田 雅代" },
  { phone: "070-7799-0960", name: "木田 雅代" },
  { phone: "070-7799-0961", name: "冨田 大介" },
  { phone: "070-7799-0904", name: "" },
  { phone: "090-4455-1896", name: "横山 あき子" },
  { phone: "090-4455-2263", name: "赤坂 美佐子" },
  { phone: "090-4455-2412", name: "西川 文恵" },
  { phone: "090-4455-2441", name: "佐藤 真奈美" },
  { phone: "090-4491-1966", name: "藤澤 裕子" },
  { phone: "090-4491-3010", name: "" },
  { phone: "090-4491-3022", name: "栃尾 竜子" },
  { phone: "090-4491-3031", name: "齋藤 久美子" },
  { phone: "090-4491-3046", name: "佐藤 真奈美" },
  { phone: "090-4491-3048", name: "NTT工事用" },
  { phone: "090-4491-3053", name: "NTT工事用" },
  { phone: "090-4491-3055", name: "NTT工事用" },
  { phone: "090-4491-3057", name: "NTT工事用" },
  { phone: "090-4491-3065", name: "NTT工事用" },
  { phone: "090-4491-3075", name: "NTT工事用" },
  { phone: "090-4491-3079", name: "NTT工事用" },
  { phone: "090-4491-3093", name: "NTT工事用" },
  { phone: "070-7790-3263", name: "桜井 憲児朗" },
  { phone: "090-4491-3095", name: "NTT工事用" },
  { phone: "090-4491-3097", name: "NTT工事用" },
  { phone: "090-4491-3108", name: "NTT工事用" },
  { phone: "090-4491-3116", name: "NTT工事用" },
  { phone: "090-4491-3123", name: "NTT工事用" },
  { phone: "090-4491-3138", name: "NTT工事用" },
  { phone: "090-4491-3140", name: "NTT工事用" },
  { phone: "090-4491-3162", name: "NTT工事用" },
  { phone: "090-4491-3166", name: "NTT工事用" },
  { phone: "070-7799-0906", name: "倉田 由起子" },
  { phone: "070-8817-1963", name: "小野田 光一" },
  { phone: "070-7790-3256", name: "長尾 美百合" },
  { phone: "070-2166-4627", name: "服部 美智代" },
  { phone: "070-7799-0932", name: "中山 扶美" },
  { phone: "080-5982-9239", name: "内藤 徳子" },
  { phone: "080-5973-7073", name: "小野田 光一" },
  { phone: "070-7799-0891", name: "田内 圭子" },
  { phone: "070-7790-3259", name: "池田 真実" },
  { phone: "070-7790-3254", name: "川島 早苗" },
  { phone: "070-7799-0952", name: "" },
  { phone: "070-7799-0938", name: "" },
  { phone: "070-7790-3262", name: "九里 智佳" },
  { phone: "070-8817-7889", name: "家久来 玲子" },
  { phone: "090-4455-1838", name: "大泉 直子" },
];


const SHEET_ID = getEnv("VUE_APP_SHEET_ID") || '1U4af0bCt_C_WtsLs2mVWbPOgFJFEsw5loZMrb85ojtg';
const GID = getEnv("VUE_APP_SOFT_PHONE_INFO_GID") || '2012414145';

try {
const data = await retrieveProdInformation(SHEET_ID, GID);

if (!data?.table?.rows || !Array.isArray(data.table.rows)) {
  console.warn("Invalid Google Sheet response:", data);
} else {
  const rows = data.table.rows.slice(1).map((row) => ({
    phone: row.c[0]?.v || "",
    name: row.c[1]?.v || "",
  }));

  if (rows.length > 0) {
    soft_phone_info = rows;
  }
}
} catch (error) {
  console.error("Failed to load soft phone info:", error);
}
const normalize = (value) => {
  if (!value) return null;
  const s = String(value).trim();
  if (!s) return null;
  return s.includes("_") ? s.slice(-4) : s;
};

const extractDestInfo = (to, from) => {
  let destInfo = null;
  const toNorm = normalize(to);
  const fromNorm = normalize(from);

  const toRaw = to ? String(to).trim() : null;
  const fromRaw = from ? String(from).trim() : null;
  if (toRaw && toRaw.includes("_")) {
    destInfo = getDestinationInfoByExtension(toNorm);
  } else {
    destInfo = getDestinationInfoByExtension(toRaw);
  }
  if (destInfo) {
    return destInfo;
  } else {
    if (fromRaw && fromRaw.includes("_")) {
      destInfo = getDestinationInfoByExtension(fromNorm);
    } else {
      destInfo = getDestinationInfoByExtension(fromRaw);
    }
    if (destInfo) {
      return destInfo;
    }
  }
};

const parseSipMessages = (sipData) => {
  if (!Array.isArray(sipData) || sipData.length === 0) return [];

  return sipData.map((msg) => {
    const payload = msg?.Full_SIP_Payload ?? "";
    const match = payload.match(/"([^@]+)@dsn\.co\.jp/i);
    let counselorname = match?.[1] ?? null;

    if (!counselorname) {
      const contactMatch = payload.match(/Contact:\s*"([^"]+)"/i);
      counselorname = contactMatch?.[1]?.trim() ?? null;
    }
    return {
      counselorname,
      From: msg?.From ?? null,
      To:   msg?.To   ?? null,
      CSEQ: msg?.CSEQ ?? null,
      Full_SIP_Payload: payload,
    };
  });
};

export const selectCounselorFromSipMessages = (sipData) => {
  const messages = parseSipMessages(sipData);
  
  if (messages?.length === 0) return null;

  const seen = new Map();

  for (const msg of messages) {
    const name = msg?.counselorname;
    if (!name) continue;

    const cseq = String(msg.CSEQ ?? "").toUpperCase();
    const payload = String(msg.Full_SIP_Payload ?? "").toUpperCase();
    const isCancel = cseq.includes("CANCEL");
    const isInvite = cseq.includes("INVITE");
    const is200Ok = /SIP\/2\.0\s+200\s+OK/i.test(payload);
    const isInvite200 = is200Ok && /CSEQ:\s*\d+\s+INVITE/i.test(payload);

    const destInfo = extractDestInfo(msg.To, msg.From);
    if (!seen.has(name)) {
      seen.set(name, { hasCancel: false, hasInvite: false, destInfo, has200Invite: false });
    }

    const entry = seen.get(name);
    if (isCancel) entry.hasCancel = true;
    if (isInvite) entry.hasInvite = true;
    if (isInvite200) entry.has200Invite = true;
  }

  // Find the first counselorname that has 200 INVITE and NO CANCEL.
  // FIRST PRIORITY: actual answered call
  for (const [name, state] of seen) {
    if (state.hasInvite && state.has200Invite) {
      return { counselorname: name, destInfo: state.destInfo };
    }
  }

  // fallback: ringing but not cancelled (less reliable)
  for (const [name, state] of seen) {
    if (state.hasInvite && !state.hasCancel) {
      return { counselorname: name, destInfo: state.destInfo };
    }
  }

  // Fallback Return the very first counselorname encountered (even though it was cancelled),
  const [firstCancelName, firstCancelState] = seen.entries().next().value ?? [];
  if (firstCancelName) {
    return { counselorname: firstCancelName, destInfo: firstCancelState.destInfo };
  }

  const ignoreWords = ["Network", "Mobile", "National", "Unknown"];

  for (const item of sipData) {
    const payload = item?.Full_SIP_Payload ?? "";

    const fromMatch = payload.match(/From:\s*"([^"]+)"/i);
    if (fromMatch?.[1]) {
      const name = fromMatch[1].trim();
      if (!ignoreWords.includes(name)) {
        return { counselorname: name, destInfo: extractDestInfo(item?.To, item?.From) };
      }
    }

    const toMatch = payload.match(/To:\s*"([^"]+)"/i);
    if (toMatch?.[1]) {
      const name = toMatch[1].trim();
      if (!ignoreWords.includes(name)) {
        return { counselorname: name, destInfo: extractDestInfo(item?.To, item?.From) };
      }
    }
  }

  return null;
};

const DESTINATION_META_FIELDS = [
  "dest_phone_name",
  "dest_model_name",
  "dest_sip_address",
  "dest_ip_address",
  "dest_department",
];

export const getCounselorNameBackfillPatch = (call) => {
  if (!call) return null;

  const sipData = Array.isArray(call?.sip_data) ? call.sip_data : [];
  const selected = selectCounselorFromSipMessages(sipData);

  const patch = {};

  // Patch counselor_name if missing or different
  if (selected?.counselorname && call?.counselor_name !== selected?.counselorname) {
    patch.counselor_name = selected.counselorname;
  }

  // Patch dest_id and related meta if different
  // const routedDestId = selected?.dest_id ?? null;
  const routedDestInfo = selected?.destInfo ?? null;
  if (routedDestInfo && call?.dest_phone_name !== routedDestInfo.dest_phone_name) {
    if(normalize(routedDestInfo.dest_phone_name) !== normalize(call?.dest_id)) patch.dest_id = normalize(routedDestInfo.dest_phone_name);

    if (routedDestInfo) {
      for (const f of DESTINATION_META_FIELDS) {
        patch[f] = routedDestInfo[f];
      }
    }
  }

  // Backfill counselor_name from soft_phone_info if still missing
  if (!patch.counselor_name && (!call?.counselor_name || call?.counselor_name === "N/A")) {
    const dest = call?.dest_id;
    const src = call?.src_id;
    
    // Check soft_phone_info by dest or src
    const entry =
      soft_phone_info.find((item) => item.phone === dest) ||
      soft_phone_info.find((item) => item.phone === src);
    
    if (entry) {
      patch.counselor_name = entry.name.includes("@dsn.co.jp") ? entry.name.split("@")[0] : entry.name;
    } else {
      // Fall back to SIP payload parsing
      const fallback = selectCounselorFromSipMessages(sipData);
      if (fallback?.counselorname) {
        patch.counselor_name = fallback.counselorname;
      }
    }
  }
  return Object.keys(patch).length ? patch : null;
};

export const getCounselorPhones = (name) => {
  const phones = soft_phone_info
    .filter((item) => item.name === name)
    .map((item) => item.phone);

  return phones.length > 0 ? phones : [];
};
